//////////////////////////////////////////////
//! UIVIEW 							-------//
//////////////////////////////////////////////
HotspotsView = function(scene,camera, dispatcher ) {

//--------------------------------------------
//! Static Vars
//--------------------------------------------
	
//--------------------------------------------
//! Vars
//--------------------------------------------
	this.scene = scene;
	this.camera = camera;
	this.dispatcher = dispatcher;
	this.visible = false;
	this.manager = new THREE.LoadingManager();

//////////////////////////////////////////////
	this.init();
//////////////////////////////////////////////

};

HotspotsView.prototype = {


	constructor: HotspotsView,
    
    /*---------------------------------------------------
		INITIALIZER
	--------------------------------------------------*/

	init : function ( ) {
		this.preloadHotspots();
		this.bindEvents();
	},

    /*---------------------------------------------------
		EVENT HANDLERS 
	--------------------------------------------------*/

	/*---------------------------------------------------
		FUNCTIONS 
	--------------------------------------------------*/
	bindEvents : function ( ) {
		this.dispatcher.addEventListener( EVENTS.SHOW_EXTRA_CONTENT, this.hideSpots.bind( this ) );
		this.dispatcher.addEventListener( EVENTS.SHOW_EXPLORE, this.showSpots.bind( this ) );
		this.dispatcher.addEventListener( EVENTS.HIDE_EXPLORE, this.hideSpots.bind( this ) );
	},
	
	preloadHotspots : function(){
		this.manager.onLoad = this.initHotspots.bind(this);
		var l = localisation.hotspot.items.length;
		for(var i = 0; i < l; i ++ ){
			var url = localisation.hotspot.items[i].image;
			localisation.hotspot.items[i].texture =  new THREE.TextureLoader(this.manager).load(url);
		}
	},

	initHotspots : function(){
		this.vector = new THREE.Vector2( this.camera.position.x, this.camera.position.y, this.camera.position.z );

		this.raycaster = new THREE.Raycaster();

		this.hotspots = new THREE.Group();
		
		var l = localisation.hotspot.items.length;

		this.hotSpotArr = [];
		for(var i = 0; i < l; i ++ ){
			var hexagon = new Hexagon( this.dispatcher, this.hotspots , localisation.hotspot.items[i].texture, localisation.hotspot.items[i].angle, localisation.hotspot.items[i].yPos,localisation.hotspot.items[i] );
			this.hotSpotArr.push(hexagon);
		}

		this.hotspotsTotal = this.hotSpotArr.length;
		this.currentHotSpot = null;
	
	},
	
	hideSpots : function(){
		for( var i = 0; i < this.hotspotsTotal; i ++ ){
				this.hotSpotArr[ i ].pulsateAnim.pause();
				this.hotSpotArr[ i ].moveBack();
		}
		this.visible = false;
		this.scene.remove( this.hotspots );
	},

	showSpots : function(){
		for( var i = 0; i < this.hotspotsTotal; i ++ ){
				this.hotSpotArr[ i ].pulsateAnim.play();
		}
		this.visible = true;
		this.scene.add( this.hotspots );
	},
	
	rayCast : function() { 

		this.raycaster.setFromCamera( this.vector, this.camera );

		this.intersects = this.raycaster.intersectObjects( this.hotspots.children, true );
	
		for ( var i = 0; i < this.intersects.length; i++ ) {
			if( ( this.intersects[ i ].object.scope )&&( this.currentHotSpot != this.intersects[ i ].object.scope ) ){

					if( this.currentHotSpot !== null ) this.currentHotSpot.moveBack();
					this.intersects[ i ].object.scope.moveFoward();
					this.currentHotSpot = this.intersects[ i ].object.scope;
					return;
			}
		}
		
		if( ( this.intersects.length === 0 ) && ( this.currentHotSpot !== null ) ){
			if( this.currentHotSpot.movingFoward ) return;
			this.currentHotSpot.moveBack();
			this.currentHotSpot = null;
		}
	},

	/*---------------------------------------------------
		RENDER
	--------------------------------------------------*/
	
	render : function ( ) {
		if(!this.visible) return;
		if(!this.hotspotsTotal) return;
		for( var i = 0; i < this.hotspotsTotal; i ++ ){
				this.hotSpotArr[ i ].render( this.camera.position );
		}
		this.rayCast();
	}

};
